import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import UserVideo from "./pages/UserVideo";
import VideoPlayer from "./pages/VideoPlayer";

const AppRouter = () => (
  <Router>
    <Routes>
      <Route path="/" element={<VideoPlayer />} />
    </Routes>
  </Router>
);

export default AppRouter;